// src/components/payoutCashFree/MyComponent.js
import AddCustomer from './addCustomer';
import ViewCustomer from './viewCustomer';

const MyComponent = (props) => {
  const { mobile, customerInfo, customerNotExist, findCustomerInfo } = props;

  return (
    <div>
      {customerNotExist && (
        <AddCustomer
          mobile={mobile}
          findCustomerInfo={findCustomerInfo}
        />
      )}
      {customerInfo && !customerNotExist && (
        <ViewCustomer
          isCustomerInfo={customerInfo}
          findCustomerInfo={findCustomerInfo}
        />
      )}
    </div>
  );
};

export default MyComponent;